export const AllContacts = `
query allContacts {
    allContacts (orderBy: POCID_ASC) {
        nodes {
            pocid
            name
            cell
            land
            email
            pubconinfo
            instruc
            datelastchanged
            document
        }
    }
}
`

export const AllContactsWithEntity = `
    query requestContacts {
        allContacts (orderBy: POCID_ASC) {
            nodes {
                entitycontactsByPocid {
                    nodes {
                        entityByFullUid {
                            name
                        }
                    }
                }
                pocid
                name
                cell
                land
                email
                pubconinfo
                instruc
                datelastchanged
                document
            }
        }
    }
`
